import { render, staticRenderFns } from "./production_detail.vue?vue&type=template&id=4be33f20&scoped=true"
import script from "./production_detail.vue?vue&type=script&lang=js"
export * from "./production_detail.vue?vue&type=script&lang=js"
import style0 from "./production_detail.vue?vue&type=style&index=0&id=4be33f20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be33f20",
  null
  
)

export default component.exports